<!-- Full-bleed hero: rotating scene backgrounds + overlay copy -->
<section class="home-hero" aria-label="GeoAstra centimeter-level accuracy">
  <div class="home-hero-slides" aria-hidden="true">
    <div
      *ngFor="let scene of heroScenes; let i = index"
      class="home-hero-slide"
      [class.is-active]="i === heroIndex"
      [class.home-hero-slide--shift-right]="!!scene.shiftRight"
      [style.background-image]="'url(' + scene.src + ')'"
      [style.background-position]="scene.position || 'center center'"
      [style.background-size]="scene.size || 'cover'"
    ></div>
  </div>
  <div class="home-hero-scrim" aria-hidden="true"></div>

  <div class="home-hero-content">
    <div class="home-hero-copy">
      <h1 class="home-hero-title">
        We Deliver <span class="home-hero-accent">CM-Level Accuracy</span>
      </h1>
      <p class="home-hero-subtitle">From software and services to professional GNSS hardware</p>
      <div class="home-hero-cta">
        <button type="button" class="btn home-hero-btn-primary btn-lg px-4" (click)="goToSoftwarePage()">
          Software and Service
        </button>
        <button type="button" class="btn home-hero-btn-secondary btn-lg px-4" (click)="goToReceiversPage()">
          GNSS Hardware
        </button>
      </div>
    </div>
  </div>

  <div class="home-hero-dots" role="tablist" aria-label="Hero scenes">
    <button
      *ngFor="let scene of heroScenes; let i = index"
      type="button"
      class="home-hero-dot"
      role="tab"
      [attr.aria-selected]="i === heroIndex"
      [attr.aria-label]="scene.alt"
      [class.is-active]="i === heroIndex"
      (click)="goToHeroSlide(i)"
    ></button>
  </div>
</section>

<!-- Lightweight product entry cards -->
<section class="home-entries">
  <div class="container-fluid px-4">
    <div class="row g-4">
      <div class="col-12 col-md-6">
        <button type="button" class="home-entry-card" (click)="goToSoftwarePage()">
          <div class="home-entry-kicker">Software and Service</div>
          <h2 class="home-entry-title">NTRIP service and RTK software</h2>
          <p class="home-entry-text">Cloud NTRIP hub and PPK toolkit for centimeter-level workflows.</p>
          <span class="home-entry-link">Explore software and service</span>
        </button>
      </div>
      <div class="col-12 col-md-6">
        <button type="button" class="home-entry-card" (click)="goToReceiversPage()">
          <div class="home-entry-kicker">Hardware</div>
          <h2 class="home-entry-title">GNSS Hardware</h2>
          <p class="home-entry-text">RTK, PPP, heading, and field-ready GNSS devices for professional positioning.</p>
          <span class="home-entry-link">Explore GNSS hardware</span>
        </button>
      </div>
    </div>
  </div>
</section>

<!-- Lightbox overlay -->
<div *ngIf="lightboxOpen" class="lightbox-backdrop" (click)="closeLightbox()">
  <div class="lightbox-content" (click)="$event.stopPropagation()">
    <button type="button" class="btn-close lightbox-close" aria-label="Close" (click)="closeLightbox()"></button>
    <img [src]="lightboxSrc" [alt]="lightboxAlt" class="img-fluid w-100" />
  </div>
</div>
